import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3254af5c&scoped=true&"
import script from "../../order/detail/detail.js?vue&type=script&lang=js&"
export * from "../../order/detail/detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=3254af5c&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254af5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3254af5c')) {
      api.createRecord('3254af5c', component.options)
    } else {
      api.reload('3254af5c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3254af5c&scoped=true&", function () {
      api.rerender('3254af5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/detailApi/detail.vue"
export default component.exports